// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-c7fsEg","banner":"banner-cQbOIG","actions":"actions-nwOOqo","openAppButton":"openAppButton-o9Cjjg","stayInBrowserButton":"stayInBrowserButton-HXOqiM"};